import React from 'react';
import pt from 'prop-types';
import { Alert, Box } from '@metarouter-private/mr-mui';

export default function ConsentRefreshNotice({ automatic = false }) {
  return (
    <Box mb={3}>
      <Alert severity="info">
        {automatic ? (
          'Consent is read when the CMP is ready, with a 3-second read deadline. Unresolved reads use the Consent Policy default, subject to GPC and existing overrides. Preference changes automatically trigger a compliance refresh in Analytics.js and standalone Sync Injector.'
        ) : (
          <>
            Consent is read once, when the built file initializes. For a mid-session consent change to take effect, the
            site must call <code>window.analytics.refreshCompliance()</code> from its CMP&apos;s consent-updated
            callback — otherwise visitors keep their original consent decision until the next page load. IAB TCF CMPs
            can instead dispatch a <code>mr:consent:refresh</code> event on <code>window</code>, which Analytics.js
            already listens for. Standalone deployments use <code>window.syncInjector.refreshCompliance()</code>.
          </>
        )}
      </Alert>
    </Box>
  );
}

ConsentRefreshNotice.propTypes = { automatic: pt.bool };
